module.exports = __webpack_public_path__ + "static/media/Poppy.4d7a4c30.png";